module.exports = __webpack_public_path__ + "04_glasses_black.cb306586.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer4/04_glasses_black.png
// module id = PJg0
// module chunks = 0